import Styled from "./ButtonStyles";

import ArrowHeadSpecial from "../../Icons/ArrowHeadSpecial";

const Button = props => {
    const { id, type, size, theme, disabled, onClick, icon } = props

    return (
        <Styled.Button
            id={id}
            onClick={onClick}
            type={type}
            size={size}
            buttontheme={theme}
            disabled={disabled}
        >
            {props.children.toUpperCase()}

            {type !== 'tertiary' && (
                <Styled.ArrowContainer type={type} size={size} buttontheme={theme} disabled={disabled} className="arrowContainer">
                    {icon ? icon : <ArrowHeadSpecial />}
                </Styled.ArrowContainer>
            )}
        </Styled.Button>
    )
}

export default Button